import React from 'react';
import Modal from 'react-modal';
import CustomCheckbox from '../customCheckbox';

const MeetingPopupDialog = ({
    open,
    setOpen,
    onStartMeeting,
    title = 'Before You Start',
    instructions = [],
}) => {
    const [isChecked, setIsChecked] = React.useState(false);

    const handleStart = () => {
        setOpen(false);
        onStartMeeting();
    };

    const commonListStyle = {
        paddingLeft: '1.25rem',
        marginTop: '0.5rem',
        marginBottom: '0.5rem',
        textAlign: 'left',
        fontSize: '0.875rem',
        color: '#000000',
    };

    return (
        <Modal
            isOpen={open}
            onRequestClose={() => setOpen(false)}
            contentLabel="Meeting Start Instructions"
            style={{
                content: {
                    backgroundColor: 'white',
                    borderRadius: '1rem',
                    boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)',
                    maxWidth: '28rem',
                    width: '100%',
                    padding: '1.5rem',
                    margin: '5rem auto',
                    inset: 'unset',
                    outline: 'none',
                },
                overlay: {
                    backgroundColor: 'rgba(0, 0, 0, 0.4)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 50,
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                },
            }}
        >
            <h2 style={{ fontSize: '1.25rem', fontWeight: '600' }}>{title}</h2>
            <ul style={commonListStyle}>
                {instructions.map((item, index) => (
                    <li key={index}>{item}</li>
                ))}
            </ul>
            <CustomCheckbox
                label="I have read and understood the above instructions."
                checked={isChecked}
                onChange={(e) => setIsChecked(e.target.checked)}
                lstyle={{ color: '#374151', fontSize: '13px' }}
                style={{ fontSize: "8px", width: "20px", height: "20px" }}
            />
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem', marginTop: '1rem' }}>
                <button
                    style={{
                        padding: '0.5rem 1rem',
                        borderRadius: '0.5rem',
                        backgroundColor: '#e5e7eb',
                        color: '#374151',
                        border: 'none',
                        cursor: 'pointer',
                    }}
                    onClick={() => { setOpen(false); setIsChecked(false); }}
                >
                    Cancel
                </button>
                <button
                    style={{
                        padding: '0.5rem 1rem',
                        borderRadius: '0.5rem',
                        color: 'white',
                        backgroundColor: isChecked ? '#2563eb' : '#9ca3af',
                        cursor: isChecked ? 'pointer' : 'not-allowed',
                        border: 'none',
                    }}
                    disabled={!isChecked}
                    onClick={handleStart}
                >
                    Start Meeting
                </button>
            </div>
        </Modal>
    );
};

export default MeetingPopupDialog;
